import type { Props } from './Svg'
import { Svg } from './Svg'

export function SunIcon(props: Props) {
  return (
    <Svg strokeWidth="2.4" {...props}>
      <path d="M11.984 18.366a6.4 6.4 0 1 0 0-12.8 6.4 6.4 0 0 0 0 12.8Zm0-12.8V1.59m0 20.8v-4.024m6.4-6.4h4.024m-20.799 0h3.975m10.958-4.51 2.812-2.86M4.615 19.335l2.86-2.812m9.067 0 2.812 2.812M4.615 4.596l2.86 2.86" />
    </Svg>
  )
}
